const Module5Config = {
	day1: {
		learn: {
			video: '5837844c4c20e438194dc0cac19e/480.m3u8',
			song: 'appfiles/distance/school_photo_montage_music_1.m4a',
			json: 'appfiles/distance/school_photo_montage_data_1.json',
		},
		celebrate: {
			video: 'e56d7d39945b3378d53187c474d5/480.m3u8',
		},
		rewardOption1: 'TreeHouseRed',
		rewardOption2: 'TreeHouseBlue',
	},
	day2: {
		learn: {
			video: 'Module5Videos/learn_day2.mp4',
			song: 'appfiles/distance/school_photo_montage_music_2.m4a',
			json: 'appfiles/distance/school_photo_montage_data_2.json',
		},
		celebrate: {
			video: 'db559a4760c6d954dc53fc67c773/480.m3u8',
		},
		rewardOption1: 'Swing',
		rewardOption2: 'TireSwing',
	},
	day3: {
		learn: {
			video: '4ee5433b9c0febc2317b999f4db5/480.m3u8',
			song: 'appfiles/distance/school_photo_montage_music_3.m4a',
			json: 'appfiles/distance/school_photo_montage_data_3.json',
		},
		celebrate: {
			video: '235163000c34de2ae3a0f74aed1a/480.m3u8',
		},
		rewardOption1: 'Ladder',
		rewardOption2: 'Stairs',
	},
	day4: {
		introVideo: 'bab25861e943c9d1278ab0ddaf06/480.m3u8',
		rewardOption1: 'ButterflyPink',
		rewardOption2: 'ButterflyBlue',
		photoTime: {
			video1: '31135407444e5f2bbe64a71c8c46/480.m3u8',
			video2: '52de722c3d975ddd0a89c485ce64/480.m3u8',
			video3: '41f9ca194a82166df536d8f36018/480.m3u8',
		},
		singingTime: {
			intro: '03bad2ccadc2fed83b6574bf463c/480.m3u8',
			demoMusic: '',
			singAlongMusic: 'appfiles/distance/distance_student_singalong.m4a',
			instrumentalMusic: 'appfiles/distance/distance_student_instrumental.m4a',
			singingAlongVideo: 'appfiles/new_files/singingtime_distance_new.mp4',
			instrumentalVideo: 'appfiles/distance/singingtime_distance_karaoke.mp4',
		},
	},
	day5: {
		introVideo: '1b9113a0d056d2838634ec34a478/480.m3u8',
		rewardOption1: 'TelescopeBlue',
		rewardOption2: 'TelescopeRed',
		learn: {
			recording: 'userfiles/{student-id}/distance_play_day_music.m4a',
			video: 'influencers/{influencer-id}/close_affirmation.mp4',
			song: 'appfiles/distance/distance_student_instrumental.m4a',
			demoSong: 'appfiles/distance/distance_student_singalong.m4a',
			json: 'appfiles/distance/school_photo_montage_data_5.json',
		},
		celebrate: {
			video: 'b66946f5efaee9ea4e433ab77380/480.m3u8',
			afterVideo: '17bd54e5c76ed78de6f9281f4031/480.m3u8',
			animal: true,
			text: 'Record yourself in an excited voice and say, "I believe in me!"',
			name: 'distance_celebration_surprise_5.mp4',
		},
	},
	day6: {
		rewardOption1: 'DuckWhite',
		rewardOption2: 'DuckColored',
		learn: {
			recording: 'userfiles/{student-id}/distance_play_day_music.m4a',
			video: 'influencers/{influencer-id}/close_affirmation.mp4',
			song: 'appfiles/distance/distance_student_instrumental.m4a',
			demoSong: 'appfiles/distance/distance_student_singalong.m4a',
			json: 'appfiles/distance/school_photo_montage_data_6.json',
		},
		celebrate: {
			video: '8f967cc3e41e2d8e274d8d6d5b06/480.m3u8',
			afterVideo: 'd30bd8e750fd11d9178a76de4ee1/480.m3u8',
			animal: true,
			text: 'Record yourself in a funny voice and say, "I believe in me!"',
			name: 'distance_celebration_surprise_6.mp4',
		},
	},
	day7: {
		rewardOption1: 'Deer',
		rewardOption2: 'Doe',
		learn: {
			recording: 'userfiles/{student-id}/distance_play_day_music.m4a',
			video: 'influencers/{influencer-id}/close_affirmation.mp4',
			song: 'appfiles/distance/distance_student_instrumental.m4a',
			demoSong: 'appfiles/distance/distance_student_singalong.m4a',
			json: 'appfiles/distance/school_photo_montage_data_7.json',
		},
		celebrate: {
			video: 'b85717d3c818f5369d82b2554a76/480.m3u8',
			afterVideo: '07f6a4e2a203f3809c1cc1cd692b/480.m3u8',
			animal: true,
			text: 'Record yourself singing, \n "I believe in me!"',
			name: 'distance_celebration_surprise_7.mp4',
		},
	},
	day8: {
		rewardOption1: 'BirdBlue',
		rewardOption2: 'BirdRed',
		learn: {
			recording: 'userfiles/{student-id}/distance_play_day_music.m4a',
			video: 'influencers/{influencer-id}/close_affirmation.mp4',
			song: 'appfiles/distance/distance_student_instrumental.m4a',
			demoSong: 'appfiles/distance/distance_student_singalong.m4a',
			json: 'appfiles/distance/school_photo_montage_data_8.json',
		},
		celebrate: {
			video: 'c2ab7952d5bf94680374988712fe/480.m3u8',
			afterVideo: 'bd9f5ee9505901c745ba8da1fd69/480.m3u8',
			animal: true,
			text: 'Record yourself making a silly face and say, "I believe in me!"',
			name: 'distance_celebration_surprise_8.mp4',
		},
	},
	day9: {
		conclusionVideo: '03a0a147c52d8ea69dc02b8ddf7b/480.m3u8',
		rewardOption1: 'HardHat',
		rewardOption2: 'Goggles',
		learn: {
			recording: 'userfiles/{student-id}/distance_play_day_music.m4a',
			video: 'influencers/{influencer-id}/close_affirmation.mp4',
			song: 'appfiles/distance/distance_student_instrumental.m4a',
			demoSong: 'appfiles/distance/distance_student_singalong.m4a',
			json: 'appfiles/distance/school_photo_montage_data_9.json',
		},
		celebrate: {
			video: 'c8c4465de20632743d63f9a6baa8/480.m3u8',
			afterVideo: null,
			animal: true,
			text: 'Record yourself dancing and say, "I believe in me!"',
			name: 'distance_celebration_surprise_9.mp4',
		},
		surprise: {
			video: '7f4a4280b9c7eaaf4c215094f69a/480.m3u8',
			song: 'appfiles/distance/distance_student_instrumental.m4a',
			slides: [
				'influencers/{influencer-id}/close_affirmation.mp4',
				'userfiles/{student-id}/distance_celebration_surprise_5.mp4',
				'userfiles/{student-id}/distance_smile.jpg',
				'influencers/{influencer-id}/distance_video_message.mp4',
				'userfiles/{student-id}/distance_celebration_surprise_8.mp4',
				'userfiles/{student-id}/distance_silly_photo_1.jpg',
				'userfiles/{student-id}/distance_celebration_surprise_9.mp4',
			],
		},
	},
}

export default Module5Config
